module.exports = __webpack_public_path__ + "static/img/logo-solgas.452c3ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-solgas.png
// module id = /8QV
// module chunks = 3